import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const getTeamPerformance =
  SettingsService.getTeamPerformanceMetricsPerformanceTeamGet

export const getIndividualPerformance =
  SettingsService.getUserPerformanceMetricsPerformanceUserGet
